import React, { useContext } from "react";
import FAQContactSection from "./FAQContactSection";
import MainHomeSection from "./MainHomeSection";
import Achivement from "./Achivement";
import AdvancedFeatures from "./AdvancedFeatures";
import Industries from "./Industries";
import Cta from "../common/Cta";
import Pricing from "../PricingPage/Pricing";
import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import GoogleOneTap from "../../../../Googleonetab";
import MyContext from "../../../../../MyContext";
import { ToastContainer, toast } from "react-toastify";
import ChatBotHome from "../../../ChatBotHome";

export default function Home() {

   const { baseUrl } = useContext(MyContext)
    const registerUserAfterGoogleLogin = async (googleUser) => {
    // console.log(" register API CALLED", googleUser);

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Basic YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU="
    );

    const payload = {
      userid: "1",
      clientName: googleUser.email,
      password: googleUser.email,
      clientNumber: googleUser.email,
      userType: "1",
      onboardingType: "2",
      onboardedBy: "1",
      clientId: "1",
      billingName: googleUser.name,
      allowedIp: "",
      firstName: googleUser.firstName,
      lastName: googleUser.lastName,
    };

    // console.log(" REGISTER PAYLOAD", payload);

    const response = await fetch(`${baseUrl}/api/User/register`, {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(payload),
    });

    // console.log(" HTTP STATUS:", response.status);

    const result = await response.json();
    // console.log(" REGISTER API RESPONSE:", result);

    return result;
  };

  const handleGoogleResponse = async (response) => {
    try {
      if (!response?.credential) return;

      const base64Url = response.credential.split(".")[1];
      const decodedData = JSON.parse(
        atob(base64Url.replace(/-/g, "+").replace(/_/g, "/"))
      );

      const googleUser = {
        name: decodedData.name,
        email: decodedData.email,
      };

      const registerResult = await registerUserAfterGoogleLogin(googleUser);

      if (registerResult?.responseCode !== "00") {
        toast.error(registerResult?.responseMessage || "Registration failed");
        return;
      }

      sessionStorage.setItem("user", JSON.stringify(registerResult.response));

      sessionStorage.setItem("power", "1");

      toast.success("Login successful");

      setTimeout(() => {
        window.location.href = "/Dashboard";
      }, 1500);
    } catch (err) {
      console.error("GOOGLE LOGIN ERROR", err);
      toast.error("Something went wrong");
    }
  };

  return (
    <div>

      <div className="d-flex justify-content-center">
        <ToastContainer />
      </div>
      <Navbar />
      <MainHomeSection />
      <Achivement />
      <Industries />
      <AdvancedFeatures />
      <Pricing />
      <FAQContactSection />
      <Cta />
      <ChatBotHome/>
      <Footer />
      {!sessionStorage.getItem("user") && (
              <GoogleOneTap onSuccess={handleGoogleResponse} />
            )}
    </div>
  );
}
